const SESSION_KEY_PREFIX = 'pozytron_temp_facility_';
const DRAFT_KEY_PREFIX = 'pozytron_draft_facility_';

/**
 * Returns the list of tempFacilityIds stored for a given clientId.
 * Returns an empty array if nothing is stored or sessionStorage is unavailable.
 */
export const getFacilitySession = (clientId: string): string[] => {
  try {
    const raw = sessionStorage.getItem(`${SESSION_KEY_PREFIX}${clientId}`);
    return raw ? (JSON.parse(raw) as string[]) : [];
  } catch {
    return [];
  }
};

/**
 * Saves the list of tempFacilityIds for a given clientId.
 */
export const setFacilitySession = (clientId: string, ids: string[]): void => {
  try {
    sessionStorage.setItem(
      `${SESSION_KEY_PREFIX}${clientId}`,
      JSON.stringify(ids)
    );
  } catch {
    // sessionStorage may be unavailable in some private-browsing environments
  }
};

/**
 * Removes the session entry for a given clientId (call after successful submit).
 */
export const clearFacilitySession = (clientId: string): void => {
  try {
    sessionStorage.removeItem(`${SESSION_KEY_PREFIX}${clientId}`);
  } catch {
    // ignore
  }
};

// ── Draft facility (ready to finalize) ───────────────────────────────────────

/**
 * Returns the draft facilityId (UUID) stored for a given clientId.
 * This is the facility that has been fully populated and is ready to finalize.
 * Returns null if nothing is stored or sessionStorage is unavailable.
 */
export const getDraftFacilityId = (clientId: string): string | null => {
  try {
    return sessionStorage.getItem(`${DRAFT_KEY_PREFIX}${clientId}`);
  } catch {
    return null;
  }
};

/**
 * Saves the draft facilityId for a given clientId.
 */
export const setDraftFacilityId = (clientId: string, id: string): void => {
  try {
    sessionStorage.setItem(`${DRAFT_KEY_PREFIX}${clientId}`, id);
  } catch {
    // sessionStorage may be unavailable in some private-browsing environments
  }
};

/**
 * Removes the draft facilityId for a given clientId (call after successful finalize).
 */
export const clearDraftFacilityId = (clientId: string): void => {
  try {
    sessionStorage.removeItem(`${DRAFT_KEY_PREFIX}${clientId}`);
  } catch {
    // ignore
  }
};
